import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TertiaryButton from '../../../Components/Buttons/TertiaryButton/TertiaryButton.component';
import InputTextNested from '../../../Components/Form/InputTextNested';
import ProvinceInput from '../../../Components/Form/ProvinceInput.component';
import SecondaryButton from '../../../Components/Buttons/SecondaryButton/SecondaryButton.component';

const BillingAddress = ({
  newAddress,
  setNewAddress,
  address,
  companyName,
}) => {
  const [editAddress, setEditAddress] = useState(false);

  const editBillingAddress = (e) => {
    e.preventDefault();
    setEditAddress(!editAddress);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEditAddress(!editAddress);
  };
  return (
    <aside className="billing">
      <h4>
        Billing Address
        <TertiaryButton
          span="Edit"
          functionName={editBillingAddress}
          className="edit-button"
        />
      </h4>
      {editAddress ? (
        <>
          <form onSubmit={handleSubmit}>
            <InputTextNested
              title="Street"
              name="street"
              value={newAddress.street || ''}
              nestedValue={setNewAddress}
              upperValue={newAddress}
            />
            <InputTextNested
              title="City"
              name="city"
              value={newAddress.city || ''}
              nestedValue={setNewAddress}
              upperValue={newAddress}
            />
            <ProvinceInput
              title="Province"
              name="province"
              value={newAddress?.province}
              upperValue={newAddress}
              nestedValue={setNewAddress}
            />
            <InputTextNested
              title="Postal Code"
              name="postalCode"
              value={newAddress.postalCode || ''}
              nestedValue={setNewAddress}
              upperValue={newAddress}
            />
            <div className="button-container">
              <SecondaryButton
                span="Save Address"
                functionName={handleSubmit}
              />
            </div>
          </form>
        </>
      ) : (
        <>
          <p>{companyName}</p>
          <address>
            {newAddress?.street || address?.street},{' '}
            {newAddress?.city || address?.city},{' '}
            {newAddress?.province || address?.province},{' '}
            {newAddress?.postalCode || address?.postalCode}
          </address>
        </>
      )}
    </aside>
  );
};
BillingAddress.propTypes = {
  newAddress: PropTypes.shape({
    street: PropTypes.string,
    city: PropTypes.string,
    province: PropTypes.string,
    postalCode: PropTypes.string,
  }),
  setNewAddress: PropTypes.func,
  companyName: PropTypes.string,
  address: PropTypes.shape({
    street: PropTypes.string,
    city: PropTypes.string,
    province: PropTypes.string,
    postalCode: PropTypes.string,
  }),
};

export default BillingAddress;
